import React, { HTMLAttributes } from "react";

interface DividerProps extends HTMLAttributes<HTMLHRElement> {
  /**
   * @example
   * ```jsx
   * <Divider />
   * ```
   */
}

/**
 * Divider Component
 *
 * @example
 * <Divider />
 */

export const Divider: React.FC<DividerProps> = ({ ...props }) => {
  return <hr className={`bg-divider ${props.className}`} {...props} />;
};
